import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 990,
      lg: 1200,
      xl: 1536
    }
  },
  palette: {
    primary: {
      main: '#338f9d'
    },
    secondary: {
      main: '#bbdae1'
    },
    error: {
      main: '#E30000',
    },
    warning: {
      main: '#CE7C00'
    },
    success: {
      main: '#00CC76',
    },
    background: {
      //default: '#f7fcfc'
      default: '#E2F4F6'
    },
    text: {
      primary: '#073842',
      hint: '#e0f2f5'
    }
  },
  typography: {
    fontFamily: "'Mulish', sans-serif",
  },
  scrollbars: {
    default: {
      '&::-webkit-scrollbar': {
        width: 16,
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#b2c7d080',
        border: '4px solid #E2F4F6',
        borderRadius: 16
      }
    },
    paper: {
      '&::-webkit-scrollbar': {
        width: 16,
        backgroundColor: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#b2c7d080',
        border: '4px solid #ffffff',
        borderRadius: 16
      }
    }
  },
  app: {
    tool: {
      headerHeight: '80px',
      leftPanelWidth: '120px',
    }
  },
  components: {
    MuiPopover: {
      styleOverrides: {
        paper: {
          borderRadius: '8px',
          boxShadow: '0 1px 5px 0 rgba(127, 131, 127, 0.21)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: '0 1px 5px 0 rgba(127, 127, 227, 0.21)',
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'unset',
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
        outlined: {
          borderRadius: '6px',
          borderWidth: '2px',
          '&:hover': {
            borderWidth: '2px',
          }
        },
        contained: {
          borderRadius: '6px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          }
        }
      }
    },
  }
});

export default theme;